import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Features.css';

const Features = () => {
  const { t } = useTranslation();
  const featuresRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (featuresRef.current) {
      observer.observe(featuresRef.current);
    }

    return () => {
      if (featuresRef.current) {
        observer.unobserve(featuresRef.current);
      }
    };
  }, []);

  const features = [
    {
      icon: '🏆',
      title: t('features.cards.quality.title'),
      description: t('features.cards.quality.description')
    },
    {
      icon: '⚡',
      title: t('features.cards.delivery.title'),
      description: t('features.cards.delivery.description')
    },
    {
      icon: '💎',
      title: t('features.cards.design.title'),
      description: t('features.cards.design.description')
    }
  ];

  const stats = [
    { number: '12+', label: t('features.stats.experience') },
    { number: '1000+', label: t('features.stats.projects') },
    { number: '50+', label: t('features.stats.varieties') },
    { number: '99%', label: t('features.stats.satisfaction') }
  ];

  return (
    <section className="features-section" ref={featuresRef}>
      <div className="features-container">
        <h2 className="section-title">{t('features.title')}</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="stats-container">
        {stats.map((stat, index) => (
          <div key={index} className="stat-item">
            <div className="stat-number">{stat.number}</div>
            <div className="stat-label">{stat.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features; 